import { useState } from 'react'
import KnowledgeDatatableComponentGridView from '../../../components/UI/KnowledgeDatatableComponent/KnowledgeDatatableComponentGridView'
import './AllKnowledge.scss'

import { useTranslation } from 'react-i18next'
import { Box, Stack, Typography } from '@mui/material'
import KnowledgeCarousel from '@/components/UI/KnowledgeDatatableComponent/KnowledgeCrousel'

const AllKnowledge = () => {
  const { t } = useTranslation('translation')
  const [showQuickAccess, setShowQuickAccess] = useState(true)

  return (
    <section className="page-mid-wraper h-without-foter">
      <Box
        sx={{
          position: 'sticky',
          top: '-16px',
          zIndex: 10,
          background: 'white',
          marginTop: '-16px',
          pb: '16px',
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          mb="12px"
        >
          <Typography variant="subtitle1" component="h2">
            {t('Knowledge')}
          </Typography>
          <Typography
            color="primary"
            sx={{ fontSize: '14px', fontWeight: 500, cursor: 'pointer' }}
            onClick={() => setShowQuickAccess(!showQuickAccess)}
          >
            {showQuickAccess ? t('Hide') : t('Show')} {t('Quick Access')}
          </Typography>
        </Stack>
        {showQuickAccess && <KnowledgeCarousel />}
      </Box>

      <KnowledgeDatatableComponentGridView />
    </section>
  )
}

export default AllKnowledge
